const messages = {
  fr: {
    validate: "Valider",
    nouscontacter: "Nous contacter",
    nom: "Nom",
    prenom: "Prénom",
    email: "Email",
    message: "Message",
  },
  en: {
    validate: "Validate",
    nouscontacter: "Contact us",
    nom: "Last name",
    prenom: "First name",
    email: "Email",
    message: "Message",
  },
};

export default messages;
